import { authorizedAction } from 'api'
import { ErrorProp } from './'

type ReinstateResponseProps =
  | {
      success: true
    }
  | {
      success: false
      error: ErrorProp
      message?: string
    }

export type ReinstateProps = {
  userId?: string
}

export async function reinstate({
  userId,
}: ReinstateProps): Promise<ReinstateResponseProps> {
  try {
    const response = await authorizedAction({
      action: 'Student.Reinstate',
      body: {
        Username: userId,
      },
    })

    const json = (await response.json()) as ReinstateResponseProps
    if (json.success) {
      return { success: true }
    } else {
      return {
        success: false,
        error: json.error ?? json.message,
      }
    }
  } catch (e: any) {
    throw e
  }
}
